import { render, staticRenderFns } from "./vHorario.vue?vue&type=template&id=fdb2547e&scoped=true&"
import script from "./vHorario.vue?vue&type=script&lang=js&"
export * from "./vHorario.vue?vue&type=script&lang=js&"
import style0 from "./vHorario.vue?vue&type=style&index=0&id=fdb2547e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb2547e",
  null
  
)

export default component.exports